import { DashboardProProducts, DashboardProProductsMore, DesignProduct } from "../../util/Products";
import DesignProductCard from "./DesignProductCard";
import { useEffect, useRef, useState } from "react";
import "./DesignCarousel.scss";
import { Button, Drawer, Modal } from "antd";
import { CloseOutlined, EllipsisOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useRecoilValue } from "recoil";
import { mobileState } from "../../state/atoms";

enum Direction {
  Left,
  Right,
}

const ScrollStep = 500;

export interface DesignCarouselProps {
  products: DesignProduct[];
  isPro: boolean;
}

export default function DesignCarousel({
  products,
  isPro
}: DesignCarouselProps) {
  const carousel = useRef<HTMLUListElement>(null);
  const mobile = useRecoilValue(mobileState);

  const [left, setLeft] = useState(false);
  const [right, setRight] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!carousel || !carousel.current) return;

    if (carousel.current.scrollWidth <= carousel.current.clientWidth) {
      setRight(false);
    }

    const { current } = carousel;
    current.addEventListener("scroll", (ev) => {
      const width = current.clientWidth;
      const fullWidth = current.scrollWidth;
      const left = current.scrollLeft;

      setLeft(left > 0);
      setRight(width + left + 10 < fullWidth);
    });
  }, [carousel]);

  function scroll(dir: Direction) {
    if (!carousel || !carousel.current) return;
    const { current } = carousel;

    current.scroll({
      top: 0,
      left:
        dir === Direction.Left
          ? current.scrollLeft - ScrollStep
          : current.scrollLeft + ScrollStep,
      behavior: "smooth",
    });
  }

  return (
    <>
      {isPro ? (
        <>
          <section className={"products-carousel"}>
            <ul className={'pro-dashboard-carousel'}>
              {[...DashboardProProducts].map((it) => (
                <DesignProductCard product={it} key={it.key} />
              ))}
              <Button
                shape="circle"
                size="large"
                icon={<EllipsisOutlined />}
                className="pro-dashboard-item-more"
                aria-label="More"
                onClick={() => setIsModalOpen(true)}
              />
            </ul>
          </section>
          {!mobile ? (
            <Modal
              open={isModalOpen}
              className={"pro-dashboard-modal"}
              width={'auto'}
              getContainer={false}
              onCancel={() => setIsModalOpen(false)}>
              <h2>More</h2>
              <section className={"products-carousel"}>
                <ul className={'scale-images'}>
                  {[...DashboardProProductsMore].map((it) => (
                    <DesignProductCard product={it} key={it.key} />
                  ))}
                </ul>
              </section>
            </Modal>
          ) : (
            <Drawer
              placement={"bottom"}
              visible={isModalOpen}
              className={"pro-dashboard-drawer"}
              height={"80vh"}
              closeIcon={false}
              maskClosable={true}
              onClose={() => setIsModalOpen(false)}
              zIndex={1001}
            >
              <Button
                className="drawer-close-btn"
                type="text"
                icon={<CloseOutlined />}
                onClick={() => setIsModalOpen(false)}
              />
              <h2>More</h2>
              <section className={"products-carousel"}>
                <ul className={'scale-images'}>
                  {[...DashboardProProductsMore].map((it) => (
                    <DesignProductCard product={it} key={it.key} />
                  ))}
                </ul>
              </section>
            </Drawer>
          )}
        </>
      ) : (
        <>
          <section className={"products-carousel"}>
            {left && (
              <Button
                className={"bt btn-left"}
                onClick={() => scroll(Direction.Left)}
              >
                <LeftOutlined />
              </Button>
            )}
            <ul ref={carousel}>
              {products.map((it) => (
                <DesignProductCard product={it} key={it.key} />
              ))}
            </ul>
            {right && (
              <Button
                className={"bt btn-right"}
                onClick={() => scroll(Direction.Right)}
              >
                <RightOutlined />
              </Button>
            )}
          </section>
        </>
      )}
    </>
  );
}
